import React from 'react';
import StatusBadge from '../Common/StatusBadge';
import CountResolutionUI from './CountResolutionUI';
import BinaryResolutionItem from './BinaryResolutionItem';
import MetricResolutionUI from './MetricResolutionUI';
import StreakResolutionUI from './StreakResolutionUI';
import { useLanguage } from '../../contexts/LanguageContext';
import { ResolutionTypes } from '../../constants/resolutionTypes';

const ResolutionItem = ({
	resolution,
	isUpdateAllowed,
	isDeleteAllowed,
	isUpdating,
	onUpdate,
	onDelete,
	onDecrypt,
}) => {
	const { t } = useLanguage();

	if (resolution.type === ResolutionTypes.BINARY) {
		return (
			<BinaryResolutionItem
				resolution={resolution}
				isUpdateAllowed={isUpdateAllowed}
				isDeleteAllowed={isDeleteAllowed}
				isUpdating={isUpdating}
				onUpdate={onUpdate}
				onDelete={onDelete}
				onDecrypt={onDecrypt}
			/>
		);
	}

	if (resolution.type === ResolutionTypes.METRIC) {
		return (
			<MetricResolutionUI
				resolution={resolution}
				isUpdateAllowed={isUpdateAllowed}
				isUpdating={isUpdating}
				onUpdate={onUpdate}
				onDecrypt={onDecrypt}
				isDeleteAllowed={isDeleteAllowed}
				onDelete={onDelete}
			/>
		);
	}

	if (resolution.type === ResolutionTypes.STREAK) {
		return (
			<StreakResolutionUI
				resolution={resolution}
				isUpdateAllowed={isUpdateAllowed}
				isUpdating={isUpdating}
				onUpdate={onUpdate}
				onDecrypt={onDecrypt}
				isDeleteAllowed={isDeleteAllowed}
				onDelete={onDelete}
			/>
		);
	}

	return (
		<CountResolutionUI
			resolution={resolution}
			isUpdateAllowed={isUpdateAllowed}
			isUpdating={isUpdating}
			onUpdate={onUpdate}
			onDecrypt={onDecrypt}
			isDeleteAllowed={isDeleteAllowed}
			onDelete={onDelete}
		/>
	);
};

export default ResolutionItem;
